// @vendors
import { Button, Modal } from "antd";
import { useEffect, useState } from 'react';


export default function ModalConfirm({ info, handleClick }) {
    const [isLoading, setIsLoading] = useState(false);
    const [visible, setVisible] = useState(true);

    useEffect(() => { setVisible(true) }, [info])

    const onClick = async () => {
        setIsLoading(true);
        await handleClick(info.index);
    }

    return (
        <Modal
            width='400px'
            visible={visible}
            footer={[
                <Button
                    className='ant-btn-solid c-2 ant-btn-size-xs'
                    data-testId='btnSend'
                    loading={isLoading}
                    onClick={onClick}
                >
                    Confirmar
                </Button>
            ]}
            centered
            onCancel={() => { setVisible(isLoading ? true : false) }}
            closable={true}
            wrapClassName='modal-confirm'
        >
            <strong>{info.title}</strong>
            <p>{info.description}</p>
        </Modal>
    )
}